<script setup lang="ts">
import type { ShortcutJs } from "@/generated/models";
import { computed } from "vue";
import NodeIcon from "../icons/NodeIcon.vue";
import { useIconData } from "../icons/useIconData";
import { getIconFallbackLetter } from "../icons/utils";
import { useFileIcon } from "./fileIcon";
import FileIconBookmark from "./FileIconBookmark.vue";
import { isBookmarkShortcut } from "./utils";

const props = defineProps<{
  file: ShortcutJs;
}>();

const icon = useFileIcon(() => props.file);
const fallbackLetter = computed(() => getIconFallbackLetter(props.file.Name));
const { hasIcon } = useIconData(() => props.file.IconData);
</script>

<template>
  <NodeIcon
    v-if="file.IconData && hasIcon"
    :key="file.Shortcut"
    variant="outline"
    :letter="fallbackLetter"
    :shortcut="file.Shortcut"
    :icon="file.IconData"
  />
  <FileIconBookmark v-else-if="isBookmarkShortcut(file)" :file="file" />
  <component :is="icon" v-else aria-hidden="true" />
</template>
